import React, { useEffect } from 'react';
import { Layout, ConfigProvider, Spin } from 'antd';
import { getTheme, useTheme } from '../../resources/theme';
import ContentLayout from './layout/content-layout';
import FooterLayout from './layout/footer-layout';
import { useDispatch, useSelector } from 'react-redux';
import { loginLineRequest } from '../../redux/line/action';
import { useGetMe } from './hooks/useGetMe';
import { setInfo } from '../../redux/info/action';
import { setCookies } from '../../store/useCookies';

const LayoutPage = () => {
  const { sidebarMode, globalTheme } = useTheme();
  const userProfile = useSelector((state) => state.line.profile);
  const dispatch = useDispatch();
  const { mutate: onCallMe, isPending: isLoadingMe } = useGetMe();
  const branchId = localStorage.getItem('branchId');

  useEffect(() => {
    if (!userProfile.userId) dispatch(loginLineRequest());
  }, [dispatch, userProfile?.userId]);

  useEffect(() => {
    if (userProfile?.userId && branchId) {
      onCallMe(
        { lineUid: userProfile?.userId, branchId },
        {
          onSuccess: (info) => {
            dispatch(setInfo(info?.result?.employee));
            setCookies('accessToken', info?.result?.employee?.accessToken);
          },
        },
      );
    }
  }, [dispatch, userProfile, onCallMe, branchId]);

  return (
    <Spin spinning={isLoadingMe}>
      <ConfigProvider theme={globalTheme}>
        <Layout
          className="site-layout"
          style={{
            height: '100vh',
          }}
        >
          <ContentLayout getTheme={getTheme} sidebarMode={sidebarMode} />
          <FooterLayout />
        </Layout>
      </ConfigProvider>
    </Spin>
  );
};

export default LayoutPage;
